import React from 'react';
import { cn } from '../../lib/utils';

const badgeVariants = {
  default: 'bg-slate-100 text-slate-700',
  success: 'bg-emerald-50 text-emerald-700',
  warning: 'bg-amber-50 text-amber-700',
  danger: 'bg-rose-50 text-rose-700',
  info: 'bg-blue-50 text-blue-700'
};

export function Badge({ className, variant = 'default', ...props }) {
  return (
    <span
      className={cn('inline-flex items-center rounded-none px-2.5 py-1 text-xs font-semibold', badgeVariants[variant], className)}
      {...props}
    />
  );
}